<template>
    <div >

 

        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <p class="is-size-5"> Status  </p>
                </div>
                <div class="level-item">
                    <p v-if="dataBiopsySpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataBiopsySpecLN.status.name }}  </p>
                    <p v-if="dataBiopsySpecLN.status.id >=5 && dataBiopsySpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataBiopsySpecLN.status.name }}  </p>
                    <p v-if="dataBiopsySpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataBiopsySpecLN.status.name }} </p>
                </div>
                <div class="level-item">
                    <b-icon icon="lock" type="is-danger"  v-if="dataBiopsySpecLN.status.id >=5 "  ></b-icon>
                    <b-icon icon="lock-open" type="is-success"  v-if="dataBiopsySpecLN.status.id < 5 "  ></b-icon>
                </div>
                <div class="level-item">
                    <p class="is-size-5"> Assigned for </p>
                </div>
                <div class="level-item">
                    <p class="is-size-5 has-text-grey"> &nbsp; {{ dataBiopsySpecLN.assigned_to_user.name }}</p>
                </div>
                <div class="level-item">
                    <b-button type="is-success"
                              id="button_edit"
                              icon-left="pencil"
                              @click="showEditDocLABTxtKind"
                              ref="btnEditLNNonautomate"
                              :disabled="!IDLABSelected.idlab "
                              v-if="
                                (
                                (  (dataBiopsySpecLN && (userRoleFind(3) || userRoleFind(4)  ))     )
                                || ( dataBiopsySpecLN && userIsAdmin )
                                ||  ( dataBiopsySpecLN && dataBiopsySpecLN.assigned_to_user.id === user_id )
                                )
                                && dataBiopsySpecLN.status.id <=5
                                        ">
                        Edit
                    </b-button>
                </div>
                <div class="level-item">
                    <b-button type="is-primary  is-light" icon-left="file-pdf-box" :disabled="loadingReportFile  " v-if="dataBiopsySpecLN.status.id >=5 && userRoleFind(6)" :loading="loadingReportFile"  @click="reqReportFile(false,-1,[])">View as Pdf(Text)</b-button>
<!--                    <b-button type="is-warning"-->
<!--                              icon-left="arrow-right-bold-circle"-->
<!--                              v-if="dataBiopsySpecLN.status.id === 5"-->
<!--                              @click="changeStatusFromIncompleteToComplete(IDLABSelected.idlab,IDLABSelected.kind)"-->
<!--                    >-->
<!--                        Change Status from Incomplete To Complete-->
<!--                    </b-button>-->
                </div>
                <div class="level-item">
                    <b-button type="is-primary  is-light" icon-left="file-pdf-box"  v-if="dataBiopsySpecLN.status.id >=5 && userRoleFind(6)" :disabled="!dataBiopsySpecLN.display_title_image_for_nonadmin ||loadingImgReportFile "  :loading="loadingImgReportFile"  @click="reqImageReportFile">View as Pdf(Images)</b-button>
                </div>
            </div>


            <div class="level-right" v-if="( (dataBiopsySpecLN.assigned_to_user.id === user_id )||(userIsAdmin) )&& (  dataBiopsySpecLN.status.id >= 5 &&  dataBiopsySpecLN.status.id <= 6)">
                <div class="level-item">
                    <b-button type="is-danger"
                              icon-left="plus"
                              class="btn_plus"
                              @click="plusSomething">Plus
                    </b-button>
                </div>
                <div class="level-item">
                    <b-field
                            :type="{ 'is-danger': hasErrorPlusSomethingSelected}"
                            :message="{ 'pls select  ': hasErrorPlusSomethingSelected}">
                        <b-select placeholder="Select Plus Type" v-model="plusSomethingSelected">
                            <option value = 0> {{headerInfoPrepare}} </option>
                            <option value = 1> {{findingAndContent}} </option>
                            <option value = 2> {{images_title}} </option>
                            <option value = 3> {{ClassificationOfDiseases}} </option>
                        </b-select>
                    </b-field>
                </div>
            </div>

        </nav>
        <hr>




        <div v-if="dataBiopsySpecLN !==null && dataBiopsySpecLN.status.id >= 5 && dataBiopsySpecLN.status.id <=6 " style="margin-left: 10px;">


            <!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="dataBiopsySpecLN.dat_prepare.dat_txt.length>0 || dataBiopsySpecLN && dataBiopsySpecLN.data_plus.dat_prepare.length>0 ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="headerPrepareInfo"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconFileDocument"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->


            <div class="container" v-if="  displayTitle(dataBiopsySpecLN.dat_prepare.dat_txt , dataBiopsySpecLN.data_plus.dat_prepare , dataBiopsySpecLN.display_title_prepare_for_nonadmin ) ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>


            <!----------------------  Prepared   disPlayOrNot   dataBiopsySpecLN && dataBiopsySpecLN.dat_prepare.dat_txt.length>0  ------>
            <div class="container"  v-if="disPlayOrNot(dataBiopsySpecLN ,dataBiopsySpecLN.dat_prepare.dat_txt.length ,dataBiopsySpecLN.dat_prepare.visible )" >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataBiopsySpecLN.dat_prepare.visible "/>
                <div class="box"  >
                    <div  v-html="getDecodeFromBase64ToHtml( dataBiopsySpecLN.dat_prepare.dat )"
                          :style= "getStyleVisibleFalseInContent(dataBiopsySpecLN.dat_prepare.visible)" >
                    </div>
                </div>
                <FooterPlus  :user_rec="dataBiopsySpecLN.dat_prepare.user_rec"
                             :date_rec="dataBiopsySpecLN.dat_prepare.date_rec"
                             :time_rec="dataBiopsySpecLN.dat_prepare.time_rec"
                             :user_delete="dataBiopsySpecLN.dat_prepare.user_edit"
                             :date_delete="dataBiopsySpecLN.dat_prepare.date_edit"
                             :time_delete="dataBiopsySpecLN.dat_prepare.time_edit"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataBiopsySpecLN.dat_prepare.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"
                             :labKind = "IDLABSelected.kind"
                             :canDelete ="dataBiopsySpecLN.dat_prepare.visible"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div>
            <!----------------------- Prepare Plus  dataBiopsySpecLN && dataBiopsySpecLN.data_plus.dat_prepare.length>0 -->
            <div class="container" v-for="dat_prepare_plus in  dataBiopsySpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">
                <div  class="container" v-if="disPlayOrNot(true,true,dat_prepare_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="headerPrepareInfoPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_prepare_plus.visible "
                    />
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_prepare_plus.dat)"  :style= "getStyleVisibleFalseInContent(dat_prepare_plus.visible)"
                        >
                        </div>
                    </div>
                    <FooterPlus  :user_rec="dat_prepare_plus.user_rec"
                                 :date_rec="dat_prepare_plus.date_rec"
                                 :time_rec="dat_prepare_plus.time_rec"
                                 :user_delete="dat_prepare_plus.user_edit"
                                 :date_delete="dat_prepare_plus.date_edit"
                                 :time_delete="dat_prepare_plus.time_edit"
                                 :canDelete ="dat_prepare_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_prepare_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                    />
                </div>
            </div>



            <!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="dataBiopsySpecLN.dat_ct.dat_txt.length>0 || dataBiopsySpecLN && dataBiopsySpecLN.data_plus.dat_ct.length>0 ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="findingAndContent"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconFileDocument"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->


            <div class="container" v-if=" displayTitle(dataBiopsySpecLN.dat_ct.dat , dataBiopsySpecLN.data_plus.dat_ct ,dataBiopsySpecLN.display_title_ct_for_nonadmin ) ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>



            <!----------------------  Content  ------>
            <div class="container"  v-if="disPlayOrNot(dataBiopsySpecLN ,dataBiopsySpecLN.dat_ct.dat_txt.length ,dataBiopsySpecLN.dat_ct.visible )" >

                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataBiopsySpecLN.dat_ct.visible "/>
                <div class="box"  >
                    <div v-html="getDecodeFromBase64ToHtml( dataBiopsySpecLN.dat_ct.dat )"  :style= "getStyleVisibleFalseInContent(dataBiopsySpecLN.dat_ct.visible)"></div>
                </div>

                <FooterPlus  :user_rec="dataBiopsySpecLN.dat_ct.user_rec"
                             :date_rec="dataBiopsySpecLN.dat_ct.date_rec"
                             :time_rec="dataBiopsySpecLN.dat_ct.time_rec"
                             :user_delete="dataBiopsySpecLN.dat_ct.user_edit"
                             :date_delete="dataBiopsySpecLN.dat_ct.date_edit"
                             :time_delete="dataBiopsySpecLN.dat_ct.time_edit"
                             :canDelete ="dataBiopsySpecLN.dat_ct.visible"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataBiopsySpecLN.dat_ct.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct"
                             :labKind = "IDLABSelected.kind"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />


            </div>

            <!--           Content Plus  -->
            <div  class="container"  v-for="dat_content_plus in  dataBiopsySpecLN.data_plus.dat_ct" :key="dat_content_plus.id">
                <template v-if="disPlayOrNot(true,true,dat_content_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="findingAndContentPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_content_plus.visible "/>
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_content_plus.dat)" :style= "getStyleVisibleFalseInContent(dat_content_plus.visible)"></div>
                    </div>
                    <FooterPlus  :user_rec="dat_content_plus.user_rec"
                                 :date_rec="dat_content_plus.date_rec"
                                 :time_rec="dat_content_plus.time_rec"
                                 :user_delete="dat_content_plus.user_edit"
                                 :date_delete="dat_content_plus.date_edit"
                                 :time_delete="dat_content_plus.time_edit"
                                 :canDelete ="dat_content_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_content_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                </template>
            </div>







            <!-- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="  dataBiopsySpecLN.img.dat.length>0 ||   dataBiopsySpecLN.data_plus.img.length>0 ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="images_title"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconImage"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->
            <div class="container" v-if=" displayTitle(dataBiopsySpecLN.img.dat , dataBiopsySpecLN.data_plus.img , dataBiopsySpecLN.display_title_image_for_nonadmin )    ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="images_title"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconImage"
                           :visible = "true"/>
            </div>

            <!----------------------  Images  ------>
             
            <template v-if="disPlayOrNot(dataBiopsySpecLN ,dataBiopsySpecLN.img.dat.length ,
                                         dataBiopsySpecLN.img.dat.length>0 ? dataBiopsySpecLN.img.dat[0].visible : false  )">
                <div class="container"  v-if="dataBiopsySpecLN && dataBiopsySpecLN.img.dat.length>0 " >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="images_title"
                               :plus=false
                               :showDatUserWhoView = true
                               :showIcon = false
                               :showTitleDisplay = false
                    />



                    <ThumbnailImageList  v-if="dataPassThruImageList.length>0"
                                         :modeThumbnailImageList="modeThumbnailImageList"
                                         :dataPassThruImageList="dataPassThruImageList"
                                         :plus="false"/>


                    <FooterPlus  :user_rec="dataBiopsySpecLN.img.user_rec"
                                 :date_rec="dataBiopsySpecLN.img.date_rec"
                                 :time_rec="dataBiopsySpecLN.img.time_rec"
                                 :user_delete="dataBiopsySpecLN.img.user_edit"
                                 :date_delete="dataBiopsySpecLN.img.date_edit"
                                 :time_delete="dataBiopsySpecLN.img.time_edit"
                                 :canDelete ="dataBiopsySpecLN.img.user_edit.length>0 ? false : true"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                </div>

            </template>
            <!----------------------   Image Plus  ------>
            <div  class="container"  v-for=" img in dataBiopsySpecLN.data_plus.img" :key="img.idtime">
                <template v-if="disPlayOrNot(true,true,img.visible[0])">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ImagePlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :showDatUserWhoView = true
                    />
                    <br>
                    <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="true"  />
                    <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"
                                 :date_rec="getDateRecImgPlusByIdTime(img.idtime)"
                                 :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"
                                 :user_delete="img.user_edit.length>0 ? img.user_edit[0] : '' "
                                 :date_delete="img.date_edit.length>0 ? img.date_edit[0] : '' "
                                 :time_delete="img.time_edit.length>0 ? img.time_edit[0] : ''"
                                 :canDelete ="img.visible.length>0 ? img.visible[0] : false"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "img.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                    <br>
                </template>
            </div>



            <!---------------- Display Title if normal or plus existing  -->
<!--            <div class="container" v-if="  dataBiopsySpecLN.diag_code.dat.length>0 ||   dataBiopsySpecLN.data_plus.diag_code.length>0 ">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="ClassificationOfDiseases"-->
<!--                           :plus=false-->
<!--                           :showIcon = true-->
<!--                           :showDatUserWhoView = "false"-->
<!--                           :showTitleDisplay = true-->
<!--                           :iconToShow = "iconDx"-->
<!--                           :visible = "true"/>-->
<!--            </div>-->

            <div class="container" v-if="  displayTitle(dataBiopsySpecLN.diag_code.dat , dataBiopsySpecLN.data_plus.diag_code , dataBiopsySpecLN.display_title_diag_for_nonadmin)   ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="ClassificationOfDiseases"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconDx"
                           :visible = "true"/>
            </div>



            <!----------------------  Diagosis  ------>
            <template v-if="disPlayOrNot(dataBiopsySpecLN ,dataBiopsySpecLN.diag_code.dat.length ,
                                         dataBiopsySpecLN.diag_code.dat.length>0 ? dataBiopsySpecLN.diag_code.dat[0].visible : false  )">
                <div class="container"  v-if="dataBiopsySpecLN && dataBiopsySpecLN.diag_code.dat.length>0" >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ClassificationOfDiseases"
                               :plus=false
                               :showIcon = false
                               :showDatUserWhoView = "true"
                               :showTitleDisplay = false
                    />
                    <b-table             :data="isEmpty ? [] : dataBiopsySpecLN.diag_code.dat "
                                         bordered
                                         striped
                                         narrowed
                                         hoverable
                                         focusable
                                         mobile-cards
                    >


                        <b-table-column field="level1Name" label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>

                        <b-table-column field="level2Name" label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>

                        <b-table-column field="level3Name" label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>

                        <b-table-column field="level4Name" label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>

                        <b-table-column field="level5Name" label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Comment"  v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>
                    <FooterPlus  :user_rec="dataBiopsySpecLN.diag_code.user_rec"
                                 :date_rec="dataBiopsySpecLN.diag_code.date_rec"
                                 :time_rec="dataBiopsySpecLN.diag_code.time_rec"

                                 :user_delete="dataBiopsySpecLN.diag_code.user_edit"
                                 :date_delete="dataBiopsySpecLN.diag_code.date_edit"
                                 :time_delete="dataBiopsySpecLN.diag_code.time_edit"
                                 :canDelete ="dataBiopsySpecLN.diag_code.user_edit.length>0 ? false : true"

                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>
                    <br>
                </div>

            </template>

            <!----------------------         Diagosis Plus   dataBiopsySpecLN.data_plus.diag_code  v-if="dataBiopsySpecLN.data_plus.diag_code.length>0"-->

            <div  class="container"  v-for=" diag_code_plus in dataBiopsySpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">
                <template v-if="disPlayOrNot(true,true,diag_code_plus.visible)">



                    <TitlePlus
                            :datUserWhoView="getNameAndSurname"
                            :titleDisplay="ClassificationOfDiseases"
                            :plus=true
                            :showIcon = false
                            :showTitleDisplay = false
                            :showDatUserWhoView = true
                    />
                    <b-table         :data="diag_code_plus.dat"
                                     bordered
                                     striped
                                     narrowed
                                     hoverable
                                     focusable
                                     mobile-cards
                    >
                        <b-table-column   label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>
                        <b-table-column   label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>
                        <b-table-column   label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>
                        <b-table-column   label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>
                        <b-table-column   label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>
                        <b-table-column  label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>
                        <b-table-column  label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>
                        <b-table-column  label="Remark" v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>
                    <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"
                                 :date_rec="diag_code_plus.dat[0].date_rec"
                                 :time_rec="diag_code_plus.dat[0].time_rec"
                                 :user_delete="diag_code_plus.dat[0].user_edit.length>0 ? diag_code_plus.dat[0].user_edit : '' "
                                 :date_delete="diag_code_plus.dat[0].date_edit.length>0 ? diag_code_plus.dat[0].date_edit : '' "
                                 :time_delete="diag_code_plus.dat[0].time_edit.length>0 ? diag_code_plus.dat[0].time_edit : '' "
                                 :canDelete ="diag_code_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "diag_code_plus.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />

                </template>
            </div>


            <!---------------- Display Title if normal or plus existing  -->
            <div   class="container"   v-if="  dataBiopsySpecLN ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="RequestedInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconInfoRequest"
                           :visible = "true"/>
            </div>
            <!-----------------     Request Info.  ----------------->
            <div class="container"  v-if="dataBiopsySpecLN" >
                <TitlePlus
                        :datUserWhoView="getNameAndSurname"
                        :titleDisplay="RequestedInfo"
                        :plus=false
                        :showIcon = false
                        :showTitleDisplay = false
                        :showDatUserWhoView = true
                />
                <FooterRequest :dataReqToFooter="dataBiopsySpecLN.data_req"/>
            </div>
















 <!--            &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;  Prepared  &#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container"  v-if="dataBiopsySpecLN && dataBiopsySpecLN.dat_prepare.dat_txt.length>0  && dataBiopsySpecLN.dat_prepare.visible">-->
<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="headerPrepareInfo"-->
<!--                           :plus=false />-->
<!--                <div class="box"  >-->
<!--                    <div v-html="dataBiopsySpecLN.dat_prepare.dat" ></div>-->
<!--                </div>-->
<!--                <FooterPlus  :user_rec="dataBiopsySpecLN.dat_prepare.user_rec"-->
<!--                             :date_rec="dataBiopsySpecLN.dat_prepare.date_rec"-->
<!--                             :time_rec="dataBiopsySpecLN.dat_prepare.time_rec"-->
<!--                             :userIsAdmin="userIsAdmin"-->
<!--                             :idToDelete = "dataBiopsySpecLN.dat_prepare.id.toString()  "-->
<!--                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"-->
<!--                             :labKind = "IDLABSelected.kind"-->
<!--                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--            </div>-->
<!--            &lt;!&ndash;           Prepare Plus  &ndash;&gt;-->
<!--            <div class="container"  v-if="dataBiopsySpecLN && dataBiopsySpecLN.data_plus.dat_prepare.length>0" >-->
<!--                <div v-for="dat_prepare_plus in  dataBiopsySpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="headerPrepareInfoPlus"-->
<!--                               :plus=true />-->
<!--                    <div class="box"  >-->
<!--                        <div v-html="dat_prepare_plus.dat" ></div>-->
<!--                    </div>-->
<!--                    <FooterPlus  :user_rec="dat_prepare_plus.user_rec"-->
<!--                                 :date_rec="dat_prepare_plus.date_rec"-->
<!--                                 :time_rec="dat_prepare_plus.time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "dat_prepare_plus.id.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->

<!--                </div>-->
<!--            </div>-->


<!--            <hr v-if="dataBiopsySpecLN && dataBiopsySpecLN.dat_prepare.dat_txt.length>0">-->
<!--            &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;  Content  &#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container"  v-if="dataBiopsySpecLN !== null && dataBiopsySpecLN.dat_ct.dat.length>0 && dataBiopsySpecLN.dat_ct.visible " >-->

<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="findingAndContent"-->
<!--                           :plus=false />-->
<!--                <div class="box"  >-->
<!--                    <div v-html="dataBiopsySpecLN.dat_ct.dat"  ></div>-->
<!--                </div>-->

<!--                <FooterPlus  :user_rec="dataBiopsySpecLN.dat_prepare.user_rec"-->
<!--                             :date_rec="dataBiopsySpecLN.dat_prepare.date_rec"-->
<!--                             :time_rec="dataBiopsySpecLN.dat_prepare.time_rec"-->
<!--                             :userIsAdmin="userIsAdmin"-->
<!--                             :idToDelete = "  dataBiopsySpecLN.dat_ct.id.toString()  "-->
<!--                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct"-->
<!--                             :labKind = "IDLABSelected.kind"-->
<!--                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--             </div>-->
<!--            &lt;!&ndash;           Content Plus  &ndash;&gt;-->
<!--            <div class="container"  v-if="dataBiopsySpecLN !== null && dataBiopsySpecLN.data_plus.dat_ct.length>0" >-->
<!--                <div v-for="dat_content_plus in  dataBiopsySpecLN.data_plus.dat_ct" :key="dat_content_plus.id">-->
<!--                    <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                               :titleDisplay="findingAndContentPlus"-->
<!--                               :plus=true />-->
<!--                    <div class="box"  >-->
<!--                        <div v-html="dat_content_plus.dat" ></div>-->
<!--                    </div>-->
<!--                    <FooterPlus  :user_rec="dat_content_plus.user_rec"-->
<!--                                 :date_rec="dat_content_plus.date_rec"-->
<!--                                 :time_rec="dat_content_plus.time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "dat_content_plus.id.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--                </div>-->
<!--            </div>-->


<!--            <hr  v-if="dataBiopsySpecLN !== null  && dataBiopsySpecLN.dat_ct.dat.length>0">-->
<!--&lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;  Images  -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container"  v-if="dataBiopsySpecLN !== null && dataBiopsySpecLN.img.dat.length>0" >-->


<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="images_title"-->
<!--                           :plus=false />-->


<!--                <ThumbnailImageList  v-if="dataPassThruImageList.length>0"-->
<!--                                     :modeThumbnailImageList="modeThumbnailImageList"-->
<!--                                     :dataPassThruImageList="dataPassThruImageList"  />-->


<!--                <FooterPlus  :user_rec="dataBiopsySpecLN.img.user_rec"-->
<!--                             :date_rec="dataBiopsySpecLN.img.date_rec"-->
<!--                             :time_rec="dataBiopsySpecLN.img.time_rec"-->
<!--                             :userIsAdmin="userIsAdmin"-->
<!--                             :idToDelete = "IDLABSelected.idlab"-->
<!--                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images"-->
<!--                             :labKind = "IDLABSelected.kind"-->
<!--                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--            </div>-->



<!--&lt;!&ndash;           Image Plus  -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--                <div class="container"  v-if="dataBiopsySpecLN !== null && dataBiopsySpecLN.data_plus.img.length>0" >-->
<!--                    <div v-for=" img in dataBiopsySpecLN.data_plus.img" :key="img.idtime">-->
<!--                        <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                                   :titleDisplay="ImagePlus"-->
<!--                                   :plus=true />-->
<!--                        <br>-->
<!--                        <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="true"  />-->
<!--                        <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"-->
<!--                                     :date_rec="getDateRecImgPlusByIdTime(img.idtime)"-->
<!--                                     :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"-->
<!--                                     :userIsAdmin="userIsAdmin"-->
<!--                                     :idToDelete = "img.idtime.toString()"-->
<!--                                     :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"-->
<!--                                     :labKind = "IDLABSelected.kind"-->
<!--                                     @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />-->
<!--                        <br>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <hr v-if="dataBiopsySpecLN !== null && dataBiopsySpecLN.img.dat.length>0">-->


<!--            <hr v-if="dataBiopsySpecLN && dataBiopsySpecLN.img.dat.length>0">-->




<!--&lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;  Diagosis  -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;-->
<!--            <div class="container"  v-if="dataBiopsySpecLN !== null && dataBiopsySpecLN.diag_code.dat.length>0" >-->

<!--                <TitlePlus :datUserWhoView="getNameAndSurname"-->
<!--                           :titleDisplay="ClassificationOfDiseases"-->
<!--                           :plus=false />-->

<!--                <b-table :data="isEmpty ? [] : dataBiopsySpecLN.diag_code.dat "-->
<!--                         bordered-->
<!--                         striped-->
<!--                         narrowed-->
<!--                         hoverable-->
<!--                         focusable-->
<!--                         mobile-cards>-->


<!--                        <b-table-column field="level1Name" label="Chapter" v-slot="props">-->
<!--                            {{ props.row.level1Name }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column field="level2Name" label="Body System" v-slot="props">-->
<!--                            {{ props.row.level2Name }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column field="level3Name" label="Organ/Tissue"  v-slot="props">-->
<!--                            {{ props.row.level3Name }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column field="level4Name" label="Character/Subcategories"  v-slot="props">-->
<!--                            {{ props.row.level4Name }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column field="level5Name" label="Extensions"  v-slot="props">-->
<!--                            {{ props.row.level5Name }}-->
<!--                        </b-table-column>-->


<!--                        <b-table-column field="level5Name" label="Unclassified Descriptions"  v-slot="props">-->
<!--                            {{ props.row.unClassifiedCodes }}-->
<!--                        </b-table-column>-->


<!--                        <b-table-column field="level5Name" label="%"  v-slot="props">-->
<!--                            {{ props.row.labDiseasecodeAccurateName }}-->
<!--                        </b-table-column>-->


<!--                        <b-table-column field="level5Name" label="Remark" v-slot="props">-->
<!--                            {{ props.row.comment }}-->
<!--                        </b-table-column>-->






<!--                </b-table>-->

<!--                <FooterPlus  :user_rec="dataBiopsySpecLN.diag_code.user_rec"-->
<!--                             :date_rec="dataBiopsySpecLN.diag_code.date_rec"-->
<!--                             :time_rec="dataBiopsySpecLN.diag_code.time_rec"-->
<!--                             :userIsAdmin="userIsAdmin"-->
<!--                             :idToDelete = "IDLABSelected.idlab"-->
<!--                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code"-->
<!--                             :labKind = "IDLABSelected.kind"-->
<!--                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>-->




<!--            </div>-->

<!--&lt;!&ndash;            <div class="container"  v-if="dataBiopsySpecLN" >&ndash;&gt;-->
<!--&lt;!&ndash;               <FooterRequest :dataReqToFooter="dataBiopsySpecLN.data_req"/>&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;         Diagosis Plus   dataCytoSpecLN.data_plus.diag_code  v-if="dataCytoSpecLN.data_plus.diag_code.length>0"&ndash;&gt;-->
<!--            <div class="container" v-if="dataBiopsySpecLN.data_plus.diag_code.length>0">-->

<!--                <div  v-for="diag_code_plus in dataBiopsySpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">-->

<!--                    <TitlePlus-->
<!--                            :datUserWhoView="getNameAndSurname"-->
<!--                            :titleDisplay="ClassificationOfDiseases"-->
<!--                            :plus=true-->
<!--                    />-->
<!--                    <b-table         :data="diag_code_plus.dat"-->
<!--                                     bordered-->
<!--                                     striped-->
<!--                                     narrowed-->
<!--                                     hoverable-->
<!--                                     focusable-->
<!--                                     mobile-cards-->
<!--                    >-->
<!--                        <b-table-column   label="Chapter" v-slot="props">-->
<!--                            {{ props.row.level1Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Body System" v-slot="props">-->
<!--                            {{ props.row.level2Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Organ/Tissue" v-slot="props">-->
<!--                            {{ props.row.level3Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Character/Subcategories" v-slot="props">-->
<!--                            {{ props.row.level4Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column   label="Extensions" v-slot="props">-->
<!--                            {{ props.row.level5Name }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column  label="Unclassified Descriptions" v-slot="props">-->
<!--                            {{ props.row.unClassifiedCodes }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column  label="%" v-slot="props">-->
<!--                            {{ props.row.labDiseasecodeAccurateName }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column  label="Remark" v-slot="props">-->
<!--                            {{ props.row.comment }}-->
<!--                        </b-table-column>-->

<!--                    </b-table>-->

<!--                    <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"-->
<!--                                 :date_rec="diag_code_plus.dat[0].date_rec"-->
<!--                                 :time_rec="diag_code_plus.dat[0].time_rec"-->
<!--                                 :userIsAdmin="userIsAdmin"-->
<!--                                 :idToDelete = "diag_code_plus.idtime.toString()"-->
<!--                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"-->
<!--                                 :labKind = "IDLABSelected.kind"-->
<!--                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="container"  v-if="dataBiopsySpecLN !== null" >-->
<!--                <TitlePlus-->
<!--                        :datUserWhoView="getNameAndSurname"-->
<!--                        :titleDisplay="RequestedInfo"-->
<!--                        :plus=false-->
<!--                />-->
<!--                <FooterRequest :dataReqToFooter="dataBiopsySpecLN.data_req"/>-->
<!--            </div>-->
<!--            -->
<!--            -->
<!--            -->
<!--            -->
<!--            -->
        </div>


        <EditDocLabBiopsy ref="EditDocLabBiopsy"
                          :IDLABSelected="IDLABSelected"
                          @close="closeEditDocLAB"
        />
        <PlusEditor   v-if="isPlusEditor"
                      :isShowing="isPlusEditor"
                      :idlab="IDLABSelected.idlab"
                      :labKind="IDLABSelected.kind"
                      :submitTypePlusEdit="submitTypePlusEditTmp"
                      @close="closePlusEditor"
                      @closeWithChange="closePlusEditorWithChange" />
        <PlusImages  v-if="isPlusImages"
                     :isShowing="isPlusImages"
                     :idlab="IDLABSelected.idlab"
                     @closePlusImagesWithData="closePlusImagesWithData"
                     @closePlusImages="closePlusImages"/>

        <PlusSelectDiseaseCode v-if="isPlusSelectDiseaseCode"
                               :idlab="IDLABSelected.idlab"
                               :isShowing="isPlusSelectDiseaseCode"
                               @closePlusSelectDiseaseCode_WithChange = "closePlusSelectDiseaseCode_WithChange"
                               @closePlusSelectDiseaseCode="closePlusSelectDiseaseCode"/>



<!--        <SelectImgForMakePdf  v-if="isSelectImgForMakePdf"-->
<!--                              @closeSelectImgForMakePdf="closeSelectImgForMakePdf"-->
<!--                             />-->

        <b-modal
                v-model="isSelectImgForMakePdf"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SelectImgForMakePdf
                    :arrImg = "arrPropsToImgReport"
                    @closeSelectImgForMakePdfWithDataWantTo="doReqImageReportFile"
                    @closeSelectImgForMakePdf="closeSelectImgForMakePdf"/>
        </b-modal>

<!--        <EditDocLABTxtKind ref="EditDocLABTxtKind"-->
<!--                           :IDLABSelected="IDLABSelected"-->
<!--                           @close="closeEditDocLAB"-->
<!--        />-->
    </div>
</template>

<script>
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import globalconst from "../../mixins/globalconst";
    import { genUUID, getBaseURLAvartar , DATABIOPSPECLN_MODEL } from '@/utils.js'
    import {mapActions, mapState} from "vuex";
    import EditDocLabBiopsy from "./EditDocLabBiopsy";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import FooterRequest from "./FooterRequest";

    import TitlePlus from "./Plus/TitlePlus";
    import FooterPlus from "./Plus/FooterPlus";

    import PlusImages from "./Plus/PlusImages";
    import PlusEditor from "./Plus/PlusEditor";
    import PlusSelectDiseaseCode from "./Plus/PlusSelectDiseaseCode";
    import changeStatusFromIncompleteToComplete from "../../mixins/methods/changeStatusFromIncompleteToComplete";

    import disPlayOrNot from "../../mixins/methods/disPlayOrNot";
    import iconTitle from "../../mixins/data/iconTitle";
    import getStyleVisibleFalseInContent from "../../mixins/methods/getStyleVisibleFalseInContent";
    import getDecodeFromBase64ToHtml from "../../mixins/methods/getDecodeFromBase64ToHtml";
    import doReportFile from "../../mixins/methods/doReportFile";
    import displayTitle from "../../mixins/methods/displayTitle";
    import FileSaver from 'file-saver'
    import selectURL_NextFrom_DoReportFile_ByCallFrmVar from '../../mixins/methods/selectURL_NextFrom_DoReportFile_ByCallFrmVar'


    import SelectImgForMakePdf from "./SelectImgForMakePdf/SelectImgForMakePdf";

    export default {
        name: "Biopsy_EachID",
        components:{
            EditDocLabBiopsy,
            ThumbnailImageList,
            FooterRequest,

            TitlePlus,
            FooterPlus,

            PlusImages,
            PlusEditor ,
            PlusSelectDiseaseCode,

            SelectImgForMakePdf

        },
        props:{
            dataBiopsySpecLN : DATABIOPSPECLN_MODEL,
            // dataBiopsySpecLN :  { "dat_prepare": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "dat_ct": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "img": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "diag_code": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "status": { "id": "", "name": "" }, "assigned_to_user": { "id": "", "name": "" } , "data_req": []},
            IDLABSelected: null ,
        },
        mounted() {
            // console.log('mount biopsy')
            // this.dataReqToFooter = this.dataBiopsySpecLN.data_req
            // console.log('mount biopsy')
            // console.log(this.dataBiopsySpecLN)
        },
        computed:{
            ...mapState({
                user_id: state => state.master_data.user_id,
                user_role :  state => state.master_data.user_role,
                userIsAdmin:  state => state.master_data.userIsAdmin,
                OPDSelected : state => state.opd_target.opd_selected,
                clientIP: state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
            getNameAndSurname: function(){
                // return 'test'
                const userFullName = localStorage.getItem('user_name_surname')
                return  `<p class="has-text-weight-light has-text-grey-lighter" style="color: #00b89c; padding-top: 15px"> View by ${userFullName}
                          ${this.dataBiopsySpecLN.current_date}
                          ${this.dataBiopsySpecLN.current_time} </p>`
                // return localStorage.getItem('user_name_surname')
            },
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]

                return this.dataBiopsySpecLN.img.dat.map(dat => {
                    // console.log(dat)
                    // console.log(this.dataBiopsySpecLN.img.dat.length)
                    return   { id: genUUID(5) ,
                        file : null,
                        urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                        title : dat.title,
                        fileNameUploaded: dat.file,
                        fresh : false  }

                })
            }
        },
        mixins:[globalconst, userRoleFind, changeStatusFromIncompleteToComplete, disPlayOrNot, iconTitle, getStyleVisibleFalseInContent,
                getDecodeFromBase64ToHtml, doReportFile, selectURL_NextFrom_DoReportFile_ByCallFrmVar , displayTitle],
        methods:{
            ...mapActions({
                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
            }),


            closeSelectImgForMakePdf(){
                this.isSelectImgForMakePdf = false
            },

            reqImageReportFile(){
                if  (this.dataBiopsySpecLN.display_title_image_for_nonadmin){
                    // build arr
                    // {"id":1  , "descp": "lorem","select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/179452040286.jpg"}
                    // `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                    this.arrPropsToImgReport = []
                    //genUUID
                    this.dataBiopsySpecLN.img.dat.forEach(dat=>{
                        if (dat.visible){
                            this.arrPropsToImgReport.push(   {"id":genUUID(5)  , "descp": "", "select": false,"url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}` , "file": dat.file }  )
                        }
                    })
                    //
                    for(var i =0 ; i<this.dataBiopsySpecLN.data_plus.img.length;i++){
                        for(var j =0; j < this.dataBiopsySpecLN.data_plus.img[i].visible.length ; j++){
                            if (this.dataBiopsySpecLN.data_plus.img[i].visible[j]){
                                this.arrPropsToImgReport.push(
                                                              {"id":genUUID(5)  , "descp": "", "select": false,
                                                               "url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${this.dataBiopsySpecLN.data_plus.img[i].file[j]}` ,
                                                               "file": this.dataBiopsySpecLN.data_plus.img[i].file[j]
                                                              }
                                                             )
                            }
                        }

                    }


                   if ( this.arrPropsToImgReport.length >0 ){
                       this.isSelectImgForMakePdf = true
                   }else{
                       this.$buefy.dialog.alert({
                           title: 'Error',
                           message: `Nothing Images`,
                           type: 'is-danger',
                           hasIcon: true,
                           icon: 'times-circle',
                           iconPack: 'fa',
                           ariaRole: 'alertdialog',
                           ariaModal: true
                       })
                   }



                }

            },


            doReqImageReportFile(payload){
                this.isSelectImgForMakePdf = false
                var arr_img_data_want = []
                for(var i=0;i<payload.arrImg.length;i++){
                    if (payload.arrImg[i].select){
                        arr_img_data_want.push(payload.arrImg[i].file)
                    }
                }

                this.reqReportFile(true,parseInt( payload.num_of_col ) ,arr_img_data_want)


            },

            reqReportFile(pure_Img,col_if_pure_img,arr_img_data_want){
                if(pure_Img){
                    this.loadingImgReportFile = true
                    }else{
                    this.loadingReportFile = true
                }

                this.doReportFile(this.IDLABSelected,this.clientIP,pure_Img,col_if_pure_img,arr_img_data_want)
                     .then(res=>{
                         FileSaver.saveAs(this.selectURL_NextFrom_DoReportFile_ByCallFrmVar(res), `${res.file_name}.pdf`);
                         if(pure_Img){
                             this.loadingImgReportFile = false
                         }else{
                             this.loadingReportFile = false
                         }
                     })
                    .catch(err=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.response.data.msg}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
                    .finally(()=>{
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
            },








            dataAvartar(iduser,avatar){
                return  `${getBaseURLAvartar()}/user_${iduser}/${avatar}`
            },
            closeEditDocLAB(){
                this.$emit('close')
            },
            showEditDocLABTxtKind(){
                this.$refs.EditDocLabBiopsy.loadData()
                this.$refs.EditDocLabBiopsy.getMyTemplateLocal()
                this.$refs.EditDocLabBiopsy.isComponentModalActive = true
            },

            // Plus
            plusSomething(){
                if(this.plusSomethingSelected === null){
                    this.hasErrorPlusSomethingSelected = true
                    return
                }


                if(this.plusSomethingSelected  == 0){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.prepare)
                }else if (this.plusSomethingSelected  == 1){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.ct)
                }else if (this.plusSomethingSelected  == 2){
                    this.showPlusImages()
                }else if (this.plusSomethingSelected  == 3){
                    this.addPlusSelectDiseaseCode()
                }else {
                    return
                }
            },
            closePlusEditor(){
                this.isPlusEditor = false
            },
            closePlusEditorWithChange(){
                this.$emit('trigForPlusUpdate')
                this.isPlusEditor = false
            },
            closePlusImagesWithData(){
                this.isPlusImages = false
                this.$emit('trigForPlusUpdate')
            },
            closePlusImages(){
                this.isPlusImages = false
            },
            closePlusSelectDiseaseCode_WithChange(){
                this.$emit('trigForPlusUpdate')
                this.isPlusSelectDiseaseCode = false
            },
            closePlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = false
            },
            showPlusEditor(_type){
                this.submitTypePlusEditTmp = _type
                this.isPlusEditor = true
            },
            showPlusImages(){
                this.isPlusImages = true
            },
            addPlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = true
            },
            footerPlusWithChangeDisable(){
                this.$emit('trigForPlusUpdate')
            },



            //
            getTimeRecImgPlusByIdTime(_idtime){
                const member  = this.dataBiopsySpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.time_rec[0]
            },
            getDateRecImgPlusByIdTime(_idtime){
                const member  = this.dataBiopsySpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.date_rec[0]
            },
            getUserRecImgPlusByIdTime(_idtime){
                const member  = this.dataBiopsySpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.user_rec[0]
            },
            dataPassThruImageListPlus(_idtime) {
                if(this.dataBiopsySpecLN.data_plus.img.length>0) {
                    const member = this.dataBiopsySpecLN.data_plus.img.find(data => data.idtime === _idtime)
                    var tmpArr = []
                    for (var i = 0; i <= member.id.length - 1; i++) {
                        const tmp = {
                            id: member.id[i],
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${member.file[i]}`,
                            title: member.title[i],
                            fileNameUploaded: member.file[i],
                            fresh: false
                        }
                        tmpArr.push(tmp)
                    }
                    return tmpArr
                }else{
                    return []
                }
            }

        },
        data(){
            return {
                modeThumbnailImageList : "view",
                dataReqToFooter : [],
                isEmpty : false,
                // Plus
                submitTypePlusEditTmp : "",
                isPlusEditor : false,
                isModalUploadFiles : false,
                isPlusSelectDiseaseCode : false,
                isPlusImages : false,
                plusSomethingSelected : null,
                hasErrorPlusSomethingSelected : false,




                isSelectImgForMakePdf : false,
                arrPropsToImgReport : []


            }
        }
    }
</script>

<style scoped>

</style>